var map = {
	"./black.png": 84872,
	"./blue.png": 2137,
	"./cream.png": 95451,
	"./dark_green.png": 46873,
	"./gold.png": 17215,
	"./green.png": 5904,
	"./grey.png": 65816,
	"./light_blue.png": 59362,
	"./maroon.png": 16777,
	"./navy_blue.png": 51698,
	"./orange.png": 95275,
	"./pink.png": 37005,
	"./purple.png": 83767,
	"./red.png": 55868,
	"./white.png": 66002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35882;